export const PHONE_LANGS = [
  { code: "en-US", label: "English (US)" },
  { code: "en-GB", label: "English (UK)" },
  { code: "en-AU", label: "English (Australia)" },
  { code: "en-NZ", label: "English (New Zealand)" },
];
export const normPhoneLang = (v) => (PHONE_LANGS.some(l => l.code === v) ? v : "en-US");

// Language the AI phone screener listens and speaks in; English (US) is the default.
export default function PhoneLanguageSelect({ value, onChange, testid }) {
  return (
    <div>
      <label className="text-xs text-slate-400 uppercase tracking-wider">Phone language</label>
      <select data-testid={testid} value={normPhoneLang(value)} onChange={(e) => onChange(e.target.value)}
        className="tp-select w-full mt-1 px-3 py-2 rounded-lg bg-[color:var(--bg-elev)] border border-[color:var(--bd-sub)] focus:border-indigo-500 outline-none">
        {PHONE_LANGS.map(l => <option key={l.code} value={l.code}>{l.label}</option>)}
      </select>
      <div className="text-[11px] text-slate-500 mt-1">The AI phone screener listens for this accent and speaks with a matching voice.</div>
    </div>
  );
}
